import { motion } from "motion/react";

const features = [
  {
    icon: "ri-focus-3-line",
    title: "실전 중심 커리큘럼",
    description:
      "이론이 아닌 실제 경매 현장에서 바로 쓸 수 있는 실전 노하우를 가르칩니다. 모든 강의는 현직 경매 전문가가 직접 설계했습니다.",
  },
  {
    icon: "ri-file-chart-line",
    title: "데이터 기반 분석",
    description:
      "전국 경매 데이터를 실시간으로 수집하고 분석하여, 객관적인 데이터에 기반한 투자 의사결정을 도와드립니다.",
  },
  {
    icon: "ri-user-heart-line",
    title: "초보자 맞춤 가이드",
    description:
      "어려운 법률 용어와 복잡한 절차를 초보자도 이해할 수 있도록 쉽게 풀어 설명합니다. 누구나 시작할 수 있습니다.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "1:1 밀착 케어",
    description:
      "강의 수강 후에도 1:1 상담을 통해 지속적으로 투자 여정을 지원합니다. 혼자가 아닌 파트너가 함께합니다.",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "합리적인 수강료",
    description:
      "고품질 교육을 합리적인 가격에 제공합니다. 무료 입문 강의부터 시작해서 필요에 따라 단계적으로 학습할 수 있습니다.",
  },
  {
    icon: "ri-shield-check-line",
    title: "안전한 투자 문화",
    description:
      "무리한 투자를 지양하고, 리스크 관리와 안전한 수익 창출을 최우선으로 하는 건전한 투자 문화를 지향합니다.",
  },
];

const sectionVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.1 },
  },
};

const fadeUpVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] as const },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] as const },
  },
};

export default function FeaturesSection() {
  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      variants={sectionVariants}
      className="w-full py-16 md:py-20 px-4 md:px-6 bg-white"
    >
      <div className="max-w-[1280px] mx-auto">
        {/* Section Header */}
        <motion.div variants={fadeUpVariants} className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-[#C4956A]/10 text-[#C4956A] rounded-full mb-3">
            Why 강스터디
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-[#1C1917] mb-3">
            강스터디가 다른 이유
          </h2>
          <p className="text-sm text-[#8C8780] max-w-[500px] mx-auto">
            수많은 경매 교육 중에서 강스터디를 선택해야 하는
            <br />
            6가지 이유를 확인하세요
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, idx) => (
            <motion.div
              key={idx}
              variants={cardVariants}
              whileHover={{ y: -6, backgroundColor: "#F7F3EE", borderColor: "rgba(196, 149, 106, 0.3)" }}
              transition={{ type: "spring", stiffness: 300, damping: 15 }}
              className="group bg-[#FAFAF8] rounded-xl border border-[#E8E5E0] p-6 transition-colors cursor-default"
            >
              <div className="w-11 h-11 rounded-xl bg-[#C4956A]/10 flex items-center justify-center mb-4 group-hover:bg-[#C4956A]/20 transition-colors">
                <i className={`${feature.icon} text-lg text-[#C4956A]`}></i>
              </div>
              <h3 className="text-base font-bold text-[#1C1917] mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-[#8C8780] leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}